import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const CategoryService = {

  getAllCategory: async () => {
    try {
      const response = await axios.get(ENDPOINT.Category);
      return response.data;
    } catch (error) {
      console.error("Error fetching Categories:", error.message);
      throw error;
    }
  },

  getCategoryStats: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Category}/stats`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Category stats:", error.message);
      throw error;
    }
  },

  getDistinctValues: async (field) => {
    try {
      const response = await axios.get(`${ENDPOINT.Category}/distinct/${field}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching distinct values:", error.message);
      throw error;
    }
  },

  getParentCandidates: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Category}/parents`);
      return response.data;
    } catch (error) {
      console.error("Error fetching parent categories:", error.message);
      throw error;
    }
  },

  getLastCategory: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Category}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching last Category:", error.message);
      throw error;
    }
  },

  getCategoryById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Category}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Category:", error.message);
      throw error;
    }
  },

  createCategory: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Category, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating Category:", error.message);
      throw error;
    }
  },

  updateCategory: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Category}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating Category:", error.message);
      throw error;
    }
  },

  deleteCategory: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Category}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting Category:", error.message);
      throw error;
    }
  },
};